import React, { useState, useEffect } from "react";
import axios from "axios";
import { BASE_URL } from "../../../constants";
import { Container, Card, Row, Col, Button, InputGroup } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { exportStudentExcel } from "./DownloadStudents_Excel";
import ProcessingDialog from './ProcessingDialog';

const List_Students = () => {


  const [selectedSection, setSelectedSection] = useState();
  const [ddlSections, setDdlSections] = useState([]);
  
  const [fromGRNo, setFromGRNo] = useState();
  const [toGRNo, setToGRNo] = useState();

  const [instituteName, setInstituteName] = useState();

  const [reportData, setReportData] = useState([]);
  const [isProcessing, setIsProcessing] = useState(false);

  const columns = [
    // Student Details
    // { header: "Section", field: "sect_name" },
    { header: "GR No", field: "gr_no" },
    { header: "First Name", field: "stud_first_name" },
    { header: "Middle Name", field: "stud_middle_name" },
    { header: "Last Name", field: "stud_last_name" },
    { header: "Gender", field: "gender" },
    { header: "Status", field: "status" },
    { header: "Student ID", field: "student_id" },
    { header: "Aadhar No", field: "aadhar_no" },
    { header: "Date of Birth", field: "dob" },
    { header: "Birth Place", field: "birth_place" },
    { header: "Academic Year", field: "academic_year" },
    { header: "Admission Date", field: "adm_date" },
    { header: "Form No", field: "form_no" },
    { header: "Monthly / Installment", field: "mthly_inst" },

    // Current Address
    { header: "Current Address 1", field: "curr_address1" },
    { header: "Current Address 2", field: "curr_address2" },
    { header: "Current PIN Code", field: "curr_pin_code" },
    { header: "Current Telephone", field: "curr_telephone" },

    // Permanent Address
    { header: "Permanent Address 1", field: "perm_address1" },
    { header: "Permanent Address 2", field: "perm_address2" },
    { header: "Permanent District", field: "perm_district" },
    { header: "Permanent Taluka", field: "perm_taluka" },
    { header: "Permanent Country", field: "perm_country" },
    { header: "Permanent PIN Code", field: "perm_pin_code" },
    { header: "Permanent Telephone", field: "perm_telephone" },

    // Contact
    { header: "Mobile No", field: "mobile_for_sms" },
    { header: "Email", field: "email_for_corrsp" },

    // Academic
    { header: "House", field: "house" },
    { header: "Admission Std/Div", field: "adm_std_div" },
    { header: "Current Std/Div", field: "curr_std_div" },
    { header: "Religion", field: "religion" },
    { header: "Caste", field: "caste" },
    { header: "Sub Caste", field: "sub_caste" },
    { header: "Nationality", field: "nationality" },
    { header: "Mother Tongue", field: "mother_tongue" },

    // Previous School
    { header: "Last School Name", field: "last_school_name" },
    { header: "Last School Std", field: "last_school_std" },
    { header: "Last School Address 1", field: "last_school_addr1" },
    { header: "Last School Address 2", field: "last_school_addr2" },

    // Miscellaneous
    { header: "Leaving Certificate ID", field: "leave_cert_id" },
    { header: "Previous GR No", field: "prev_gr_no" },
    { header: "Next GR No", field: "next_gr_no" },
    { header: "Fee Waiver ID", field: "fee_waiver_id" },
    { header: "App Login Status", field: "app_login_status" },
    { header: "App Login Password", field: "app_login_pwd" },
    { header: "LC / BC Photo", field: "lc_bc_pic" },
    { header: "Aadhar Photo", field: "aadhar_pic" },
    { header: "Optional Subject ID", field: "opt_sub_id" },

    // Father Details
    { header: "Father First Name", field: "father_first_name" },
    { header: "Father Last Name", field: "father_last_name" },
    { header: "Father Mobile", field: "father_cell_no" },
    { header: "Father Email", field: "father_email_id" },
    { header: "Father Aadhar", field: "father_aadhar" },
    { header: "Father Qualification", field: "father_qual" },
    { header: "Father Occupation", field: "father_occup" },
    { header: "Father Firm Name", field: "father_firm_name" },
    { header: "Father Firm Address", field: "father_firm_addr" },
    { header: "Father Firm Telephone", field: "father_firm_tel" },
    { header: "Father Designation", field: "father_designation" },
    { header: "Father Age", field: "father_age" },

    // Mother Details
    { header: "Mother First Name", field: "mother_first_name" },
    { header: "Mother Last Name", field: "mother_last_name" },
    { header: "Mother Mobile", field: "mother_cell_no" },
    { header: "Mother Email", field: "mother_email_id" },
    { header: "Mother Aadhar", field: "mother_aadhar" },
    { header: "Mother Qualification", field: "mother_qual" },
    { header: "Mother Occupation", field: "mother_occup" },
    { header: "Mother Firm Name", field: "mother_firm_name" },
    { header: "Mother Firm Address", field: "mother_firm_addr" },
    { header: "Mother Firm Telephone", field: "mother_firm_tel" },
    { header: "Mother Designation", field: "mother_designation" },
    { header: "Mother Age", field: "mother_age" }

  ];


  useEffect(() => {

    loadDropdowns();

  }, []);

  const loadDropdowns = async () => {

    try {

      const sec = await axios.get(`${BASE_URL}/api/ddl_sections`);
      setDdlSections(sec.data);

    } catch (err) {

      console.error("Error loading Dropdowns", err);

    }

  };


  // Fetch report
  const handleRunReport = async () => {

    if (!selectedSection || selectedSection === '') {
      toast.error("Please select Section.");
      return;
    } else if (fromGRNo && toGRNo) {
      if (Number(fromGRNo) > Number(toGRNo)) {
        toast.error("From GR No is greater than To GR No.");
        return;
      }
    } 

    setReportData([]);
    setIsProcessing(true);

    try {

      const result = await axios.get(`${BASE_URL}/api/rpt_list_students`, {
        params: {p_section_id: selectedSection, p_from_grno: fromGRNo, p_to_grno: toGRNo } });

      setIsProcessing(false);

      if (result.data.length > 0) {
        setReportData(result.data);
        //setInstituteName(result.data[0].school_name);
      } else {
        setReportData([]);
        toast.error("No Records Found");
      }
    } catch (err) {
      setIsProcessing(false);
      console.error("Report Error:", err);
      toast.error("Error loading Report.");
    }
  };

  const selectedSectionName = ddlSections.find(sec => sec.section_id === Number(selectedSection))?.section_desc || "";
  // const selectedDivName = ddlDivisions.find(div => div.div_id === Number(selectedDiv))?.div_name || "";

  const handleDownloadExcel = () => {

    if (reportData.length === 0) {
      toast.error("No data to download");
      return;
    }

    exportStudentExcel({
      reportData,
      columns,
      instituteName,
      selectedSectionName,
    });

  };

  return (

    <Container fluid className="p-3">

      {/* Filters */}
      <Card className="p-3 mb-3">

        <Row>

          <Col md={3}>
            <InputGroup>
              <InputGroup.Text style={{ width: "80px" }}> Section 
              </InputGroup.Text>

              <select className="form-select" name="selectedSection" 
                value={selectedSection} onChange={(e) => setSelectedSection(e.target.value)} >
                <option value="">Select Section</option>
                {ddlSections.map(s => (
                  <option key={s.section_id} value={s.section_id}>{s.section_desc}</option>
                ))}
              </select>
            </InputGroup>
          </Col>

          <Col md={3}>
            <InputGroup>
              <InputGroup.Text style={{ width: "120px" }}> From GR No.
              </InputGroup.Text>
              <input name="fromGRNo" className="form-control" type="number" style={{ textAlign: "right" }}
                value={fromGRNo} onChange={(e) => setFromGRNo(e.target.value)} />
            </InputGroup>
          </Col>

          <Col md={3}>

            <InputGroup>
              <InputGroup.Text style={{ width: "120px" }}> To GR No.
              </InputGroup.Text>
              <input name="toGRNo" className="form-control" type="number" style={{ textAlign: "right" }}
                value={toGRNo} onChange={(e) => setToGRNo(e.target.value)} />
            </InputGroup>

          </Col>

         <Col md={3}>
            <Button variant="warning" className="ms-2" onClick={handleDownloadExcel}
              disabled={reportData.length === 0}> Download Excel
            </Button>
            <Button variant="success" onClick={handleRunReport} className="ms-2"> Run Report</Button>         
            {isProcessing && <ProcessingDialog isOpen={isProcessing} />}
         </Col>

        </Row>

      </Card>

      {/* Report Table style={{ minHeight: '220px' }} */}
      <Card className="p-3">
        <div className="responsive-table-reports-wrapper">
          <table style={{ maxHeight: '35px' }} className="responsive-table-reports scty-custom-table-rcpt hover-table-rcpt">
            <thead className="table-light">
              <tr>
                {columns.map(col => (
                  <th key={col.field}>{col.header}</th>
                ))}
              </tr>
            </thead>

            <tbody>
              {reportData.length > 0 ? (
                reportData.map((row) => (
                  <tr key={row.student_id}>
                    {columns.map(col => (
                      <td key={col.field}>
                        {row[col.field]}
                      </td>
                    ))}
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={columns.length} className="text-center">
                    No Data
                  </td>
                </tr>
              )}
            </tbody>

          </table>
        </div>

      </Card>

    </Container>
  );
};

export default List_Students;
